import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getDataApiCallsStatistics(): Observable<any>{
    return this.http.get(`${environment.yomaApiURL}/dashboards/statistics/data_api_calls`);
  }

}
